import React from 'react';
import {Alert, Badge, Form, Icon, Input, Button, Select, DatePicker, Row, Col, Radio, Slider } from 'antd';
import get from 'lodash/get';
import { connect } from 'react-redux';

import { updateSiteRequest, createSiteRequest } from "../../api/requests";
import {
  getSiteCreatePermission,
  getSiteUpdatePermissionBySite
} from "../../reducers/user/selectors";

import classes from './SettingsSiteForm.css';
import { logout } from "../../reducers/user/actions";

const { Option } = Select;

const timeZones = {
  'America/Edmonton': 'MT',
  'America/Vancouver': 'PT',
  'America/Winnipeg': 'CT',
  'America/Toronto': 'ET',
  'America/Halifax': 'AT',
};

class SettingsSiteForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
    };
  }

  handleSubmit = e => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const site = {...values};
          site.short_tz = timeZones[site.time_zone];

          if (this.props.id) {
            await updateSiteRequest(this.props.code , site);
          } else {
            await createSiteRequest(site);
          }

          this.setState({ isLoading: false, requestResult: { type: 'success', message: 'Success' } });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, 'response.status') === 401) { this.props.logout();  return; }
          this.setState({ isLoading: false, requestResult: { type: 'error', message: get(e, 'response.data.message', 'Error') } });

          if (get(e, 'response.data.errors')) {
            const errors = {};
            Object.keys(get(e, 'response.data.errors')).forEach(errorFieldKey => {
              errors[errorFieldKey] = {
                value: values[errorFieldKey],
                errors: get(e, `response.data.errors.${errorFieldKey}`).map(errorMessage => new Error(errorMessage))
              }
            });
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };


  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { siteUpdatePermission, siteCreatePermission, id, isNew } = this.props;

    const isEditable = id ? siteUpdatePermission : siteCreatePermission;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className='headline-default'>
            {this.props.id ? (<span>{this.props.name} <Badge count='Edit' style={{ backgroundColor: '#2968AE' }} /></span>) : isNew ? 'Add site' : ''}
          </h4>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>Code:</b>
                <Form.Item>
                  {getFieldDecorator('code', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'code', '')
                  })(
                    <Input disabled={!isEditable} placeholder='Code' />
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>Name:</b>
                <Form.Item>
                  {getFieldDecorator('name', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'name', '')
                  })(
                    <Input disabled={!isEditable} placeholder='Name' />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>
          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>Consent Workflow Type:</b>
                <Form.Item>
                  {getFieldDecorator('consent_workflow_type', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'consent_workflow_type', 'calgary')
                  })(
                    <Select>
                      <Option value='calgary'>Type 1 - Calgary</Option>
                      <Option value='edmonton'>Type 2 - Edmonton</Option>
                      <Option value='sunnybrook'>Type 3 - Sunnybrook</Option>
                      <Option value='kelowna'>Type 4 - Kelowna</Option>
                      <Option value='montreal'>Type 5 - Montreal</Option>
                      <Option value='winnipeg'>Type 6 - Winnipeg</Option>
                      <Option value='uhn'>Type 7 - UHN - Toronto Western Hospital</Option>
                      <Option value='halifax'>Type 8 - Halifax</Option>
                      <Option value='lhs'>Type 9 - London</Option>
                      <Option value='grey_nuns'>Type 10 - Grey nuns</Option>
                      <Option value='red_deer'>Type 11 - Red Deer</Option>
                      <Option value='medicine_hat'>Type 12 - Medicine Hat</Option>
                      <Option value='lethbridge'>Type 13 - Lethbridge</Option>
                      <Option value='kingston'>Type 14 - Kingston</Option>
                      <Option value='chus'>Type 15 - CHUS</Option>
                      <Option value='hamilton'>Type 16 - Hamilton</Option>
                      <Option value='ottawa'>Type 17 - Ottawa</Option>
                      <Option value='royal'>Type 18 - Royal Columbian Hospital</Option>
                      <Option value='royal_university'>Type 19 - Royal University Hospital</Option>
                      <Option value='pei'>Type 20 - Pei</Option>
                      <Option value='quebec_chu'>Type 21 - Quebec CHU</Option>
                      <Option value='vancouver'>Type 22 - Vancouver</Option>
                      <Option value='toronto_uh'>Type 23 - Toronto ST. Michaels Unity Health </Option>
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>

          </Row>
          <Row gutter={12}>
            <Col span={9}>
              <label>
                <b>Location:</b>
                <Form.Item>
                  {getFieldDecorator('location', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'location', '')
                  })(
                    <Input disabled={!isEditable} placeholder='Location' />
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={9}>
              <label>
                <b>Time Zone:</b>
                <Form.Item>
                  {getFieldDecorator('time_zone', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'time_zone', '')
                  })(
                    <Select disabled={!isEditable} placeholder='Select'>
                      <Option value="America/Edmonton">America/Edmonton</Option>
                      <Option value="America/Vancouver">America/Vancouver</Option>
                      <Option value="America/Winnipeg">America/Winnipeg</Option>
                      <Option value="America/Toronto">America/Toronto</Option>
                      <Option value="America/Halifax">America/Halifax</Option>
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
            {getFieldValue('time_zone') && <Col span={6}>
              <label>
                <b>Short TZ:</b>
                <br/>
                <div style={{ marginTop: '8px'}}>{timeZones[getFieldValue('time_zone')]}</div>
              </label>
            </Col>}
          </Row>

          {requestResult.type && (<Alert message={requestResult.message} type={requestResult.type} className={classes.submitResult} />)}

          <div className={classes.actionWrapper}>
            {isEditable && (<Form.Item>
              <Button type="primary" size="large" htmlType="submit" className={classes.submitButton}>
                Save
                {isLoading && <Icon type="loading" />}
              </Button>&nbsp; &nbsp;
            </Form.Item>)}

            <Button type="default" size="large" htmlType="button" className={classes.submitButton} onClick={this.props.onCancel}>
              Cancel
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  siteCreatePermission: getSiteCreatePermission(state),
  siteUpdatePermission: getSiteUpdatePermissionBySite(get(props, 'id'))(state)
});

const mapDispatchToProps = { logout };

export default Form.create({ name: 'site' })(connect(mapStateToProps, mapDispatchToProps)(SettingsSiteForm));



// WEBPACK FOOTER //
// ./src/components/SettingsSiteForm/SettingsSiteForm.js